export default "__VITE_ASSET__D9s5StZT__"